import React, { useContext, useEffect, useState } from 'react'
import { Field, Form, Formik, ErrorMessage } from 'formik';
import { getImages } from '../const';
import USAMap from "react-usa-map";
import html2canvas from 'html2canvas';
import { VehicleContext } from '../Context/VehicleContext';
import FitAnalysisBarChart from './FitAnalysisBarChart';
import FitFullWidthScollerPlot from './FitFullWidthScollerPlot';
const regionColors = {
    West: "#404040",
    Midwest: "#494949",
    Southwest: "#525559",
    Southeast: "#42454A",
    Northeast: "#535353",
};
const gray = "#525559";
const red = "#e52640";
const allStates = [
    "CA", "OR", "WA", "NV", "ID", "MT", "WY", "AK", "HI", "ND", "SD", "NE",
    "KS", "MN", "IA", "MO", "WI", "IL", "IN", "MI", "OH", "AZ", "NM", "TX",
    "OK", "CO", "UT", "AR", "LA", "MS", "AL", "GA", "FL", "SC", "NC", "TN",
    "KY", "WV", "VA", "ME", "NH", "VT", "MA", "RI", "CT", "NY", "NJ", "PA",
    "DE", "MD", "DC"
  ];
const regionMap = {
    WEST: { states: ["CA", "OR", "WA", "NV", "ID", "MT", "WY", "AK", "HI"], price: 66300 },
    MIDWEST: { states: ["ND", "SD", "NE", "KS", "MN", "IA", "MO", "WI", "IL", "IN", "MI", "OH"], price: 51500 },
    SOUTHWEST: { states: ["AZ", "NM", "TX", "OK", "CO", "UT"], price: 53350 },
    SOUTHEAST: { states: ["AR", "LA", "MS", "AL", "GA", "FL", "SC", "NC", "TN", "KY", "WV", "VA"], price: 57200 },
    NORTHEAST: { states: ["ME", "NH", "VT", "MA", "RI", "CT", "NY", "NJ", "PA", "DE", "MD", "DC"], price: 66900 },
};
const barData1 = [
    { x: 'Jan', y: 11 },
    { x: 'Feb', y: 19 },
    { x: 'Mar', y: 20 },
    { x: 'Apr', y: 18 },
    { x: 'May', y: 23 },
    { x: 'Jun', y: 26 },
    { x: 'Jul', y: 19 },
    { x: 'Aug', y: 19 },
    { x: 'Sep', y: 22 },
    { x: 'Oct', y: 24 },
    { x: 'Nov', y: 28 },
    { x: 'Dec', y: 27 },
]
const defaultRegion = Object.keys(regionMap)[3];
const FitAnalysisModal = ({close, data}) => {
    const { numberFormatter } = useContext(VehicleContext);

    const [selectedRegion,setSelectedRegion] = useState("SOUTHWEST");

    const [customize,setCustomize] = useState(allStates.reduce((acc, state) => {
        acc[state] = {
          fill: regionMap[selectedRegion].states.includes(state) ? red : gray
        };
        return acc;
      }, {}));

    const setMapData = (region) => {
        setCustomize(allStates.reduce((acc, state) => {
            acc[state] = {
              fill: regionMap[region].states.includes(state) ? red : gray
            };
            return acc;
          }, {}));
    }

      const [isLoading, setIsLoading] = useState(false);
      const handleDownloadReport = () => {
        setIsLoading(true);
        requestAnimationFrame(async () => {
          const element = document.querySelector('.fa-print-box');
          if (!element) {
            setIsLoading(false);
            return;
          }
      
          try {
            const canvas = await html2canvas(element, { scale: 2, useCORS: true });
            const link = document.createElement('a');
            link.download = 'report.jpg';
            link.href = canvas.toDataURL('image/jpeg', 1.0);
            link.click();
          } catch (error) {
            console.error('Download failed:', error);
          } finally {
            setIsLoading(false);
          }
        });
      };

    const [currentRegionMarket,setCurrentRegionMarket] = useState(data.market_info.find((item) => item.region == selectedRegion));

    const [nationalMarket,setNationalMarket] = useState(data.market_info.find((item) => item.region == 'NATIONAL'));

    const [soldTrend,setSoldTrend] = useState(data.sold_trend[selectedRegion]);

    useEffect(() => {
        console.log(data.location);
        const locationParts = data.location.split(', ');

        var foundRegion = selectedRegion;

        if(locationParts.length == 2) {
            console.log(Object.entries(regionMap));
            const foundRegionData = Object.entries(regionMap).find((region_data) => region_data[1].states.includes(locationParts[1]));
            foundRegion = foundRegionData[0].toUpperCase();
            
            console.log(foundRegionData,foundRegion);

            if(foundRegion) {
                setSelectedRegion(foundRegion);

                setCurrentRegionMarket(data.market_info.find((item) => item.region == foundRegion));
                setSoldTrend(data.sold_trend[foundRegion]);
        
                setMapData(foundRegion);
            }
        }

        console.log(data,data.market_info.find((item) => item.region == foundRegion),data.sold_trend[foundRegion]);
    },[data.location])
      
      
    
      
    return (
        <>

            <div className="modal-content p-0">
                <div className="modal-header p-3 chat-modal-header">
                    <h1 className="modal-title filter-modal-title text-center w-100">
                        Fit Analysis
                    </h1>
                    <button className="sm-box-close mt-0" type="button" onClick={close}>
                        <img src={getImages('white-close.svg')} />
                    </button>
                </div>
                <div className="modal-body p-0">
                    <div className='fa-print-box'>
                        <div className='fa-top d-flex align-items-center justify-content-between'>
                            <div className=''>
                                <div className='md-title text-uppercase font-2-5em fw-700'>Fit Analysis</div>
                                <div className='xs-title text-uppercase font-1em text-red fw-400'>By Experience Wholesale</div>
                            </div>
                            <div className='text-end'>
                                <div><img src={getImages('chip-ai.svg')} alt='chip'/></div>
                                <div className='xs-title font-12 mt-2'>Powered by AI</div>
                            </div>
                        </div>
                        <div className='p-4'>
                            <div className='d-flex align-items-center justify-content-between mb-3'>
                                <div>
                                    <div className='xs-title font-0-9em text-uppercase opacity-0-5 mb-2'>Prepared for</div>
                                    <div className='md-title dealer-name'>{data.dealership}</div>
                                </div>
                                <div>
                                    <img src={getImages('ew-logo-old.svg')}/>
                                </div>
                            </div>
                            <div className='fa-gray-box d-flex align-items-center justify-content-between mb-4'>
                                <div>
                                    <div className='md-title text-uppercase fw-700 fa-gray-border pb-3 mb-3'>Analysis for the <span className='text-lred'>{selectedRegion}</span></div>
                                    <div className='d-flex'>
                                        <div className='fa-left'>
                                            <img src={getImages("porsche-logo.webp")}/>
                                        </div>
                                        <div className='fa-right ps-3'>
                                            <div className='d-inline-flex'>
                                                <div className='w-100'>
                                                    <div className='md-title font-1-2em mb-2'>{data.input.year} {data.input.make} {data.input.model} {data.input.trim}</div>
                                                    <div className='d-flex align-items-center justify-content-between mb-3'>
                                                        <div className='xs-title font-1em'>{numberFormatter(data.mileage)} miles</div>
                                                        <div className='xs-title font-14 opacity-0-5'>Avg miles {numberFormatter(currentRegionMarket?.avg_mileage)}</div>
                                                    </div>
                                                    <div className='md-title fw-bold'>{numberFormatter(currentRegionMarket?.avg_price,true)}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='usa-fit-map'>
                                    <USAMap customize={customize} />
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-6'>
                                    <div className='fa-gray-box p-3'>
                                        <div className='md-title font-1-1em fw-bold text-uppercase mb-4'>Regional Demand Analysis</div>
                                        <div className='fa-table'>
                                            <table className='w-100'>
                                                <thead>
                                                    <tr>
                                                        <th>&nbsp;</th>
                                                        <th>
                                                            <div className='red-border-b'>Regional</div>
                                                        </th>
                                                        <th>
                                                            <div className='red-border-b'>National</div>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>Market Days <br/>Supply</td>
                                                        <td>{numberFormatter(currentRegionMarket?.supply_count / (currentRegionMarket?.sold_count / 90))} Days</td>
                                                        <td>{numberFormatter(nationalMarket?.supply_count / (nationalMarket?.sold_count / 90))} Days</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Adjusted % <br/>of Market</td>
                                                        <td>{numberFormatter(100 * data.price / currentRegionMarket?.avg_price)}%</td>
                                                        <td>{numberFormatter(100 * data.price / nationalMarket?.avg_price)}%</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Vehicles <br/>On Market</td>
                                                        <td>{currentRegionMarket?.supply_count}</td>
                                                        <td>{nationalMarket?.supply_count}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-6'>
                                    <div className='fa-gray-box p-3'>
                                        <div className='md-title font-1-1em fw-500 text-uppercase mb-1'>{data.input.year} {data.input.make} {data.input.model} {data.input.trim}</div>
                                        <div className='md-title font-1em fw-500 mb-4'>Sold last 6 months in <span className='text-lred'>{selectedRegion}</span></div>
                                        <div className='fa-chart-box'>
                                            {soldTrend && <FitAnalysisBarChart 
                                                isActive={true}
                                                width="100%"
                                                mxwidth="420"
                                                data={soldTrend}
                                            />}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='common-box-border my-4 d-flex align-items-center last-exchange-box'>
                                <div className='md-title font-1-1em fw-bold text-uppercase me-5'>Last Exchange</div>
                                <div className='md-title font-1-1em fw-500 text-lred'>{data.input.year} {data.input.make} {data.input.model} {data.input.trim}</div>
                                <div className='md-title font-1em fw-500 me-5 ms-auto'> miles</div>
                                <div className='md-title font-1-8em fw-bold'>${data.transactions.length > 0 ? numberFormatter(data.transactions[0].sale_price) : ""}</div>
                            </div>
                            <div className='fa-gray-box p-4'>
                                <div className='d-flex align-items-center justify-content-between mb-3'>
                                    <div className='md-title font-1-1em fw-bold text-uppercase'>{data.input.make} Inventory Mix</div>
                                    <div className='md-title font-1em fw-500'>Last 6 months in <span className='text-lred dealer-name'>{data.dealership}</span></div>
                                </div>
                                <FitFullWidthScollerPlot
                                    data={data.dealership_trend_plot}
                                    width="100%"
                                    height={300}
                                    isVisible={true}
                                    svgColor="rgb(229, 38, 64)"
                                    xAxisColor="#fff"
                                    yAxisColor="#fff"
                                    numberFormatter={numberFormatter}
                                />
                                
                                <div className='md-title font-1em fw-500 text-center mt-3'>Adding this {data.input.make} will bring your mix from  <span className='text-lred'>{numberFormatter(100*data.current_mix)}%</span> to <span className='text-lred'>{numberFormatter(100*data.new_mix)}%</span></div>

                            </div>
                        </div>
                    </div>
                    <div className='mt-0 pb-5 text-center'>
                        <button
                            type='button'
                            className='red-btn sm-btn text-uppercase downalod-report-btn'
                            onClick={handleDownloadReport}
                            disabled={isLoading}
                        >
                            {isLoading ? 'Processing...' : 'Download Report'}
                        </button>
                    </div>
                </div>
                            
            </div>
        </>
    )
}

export default FitAnalysisModal